import type { RarityLabel, SizeClass } from "../../core/types";

export const genesisRarityForSize: Readonly<Record<SizeClass, RarityLabel>> = {
  small: "common",
  medium: "uncommon",
  large: "rare",
  colossal: "mythical",
};

export const genesisSizeScale: Readonly<Record<SizeClass, number>> = {
  small: 0.85,
  medium: 1,
  large: 1.15,
  colossal: 1.32,
};
